import {
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  Typography
} from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { ScheduleWindow } from 'components/common/ScheduleWindow'
import { SERVICE_AUTOSCHEDULE_TRIGGER_TYPES } from 'components/services/service-utils'
import theme from 'theme'
import { ServiceFormValues } from 'types/forms'

export const ServiceAutoscheduling: React.FC = () => {
  const { control } = useFormContext<ServiceFormValues>()

  const isAutoSchedulingEnabled = useWatch<ServiceFormValues>({
    name: 'scheduleSettings.enabled'
  })

  return (
    <>
      <Typography data-test-service-autoscheduling-description>
        Gremlin can automatically schedule recurring Reliability Tests for this
        service when given a testing window. We will run this Service’s
        Reliability Tests during your specified window. This is optional.
      </Typography>
      <div>
        <FormGroup css={{ marginLeft: theme.space[2] }}>
          <Controller
            control={control}
            name="scheduleSettings.enabled"
            render={({ field }) => (
              <FormControlLabel
                data-test-enable-autoscheduling-switch
                checked={field.value}
                control={<Switch color="success" />}
                label="Autoschedule eligible Reliability Tests in this Service"
                {...field}
              />
            )}
          />
        </FormGroup>
        <FormGroup css={{ marginLeft: theme.space[7] }}>
          <Controller
            control={control}
            name="scheduleSettings.triggerType"
            render={({ field }) => (
              <RadioGroup {...field}>
                {SERVICE_AUTOSCHEDULE_TRIGGER_TYPES.map(
                  ({ label, value }, index) => (
                    <FormControlLabel
                      key={`${value}-${index}`}
                      control={<Radio color="success" />}
                      data-test-autoscheduling-trigger-type={value}
                      disabled={!isAutoSchedulingEnabled}
                      label={label}
                      value={value}
                    />
                  )
                )}
              </RadioGroup>
            )}
          />
        </FormGroup>
      </div>
      <div
        data-test-service-autoscheduling-test-window
        css={{ marginLeft: theme.space[7] }}
      >
        <Stack direction="column" gap={1} mb={4}>
          <Typography
            data-test-service-autoscheduling-test-window-header
            css={{ fontWeight: theme.fontWeights[1] }}
          >
            Test Window
          </Typography>
          <Typography
            data-test-service-autoscheduling-test-window-description
            css={{ marginLeft: theme.space[3] }}
          >
            Select one day per week for your eligible Reliability Tests to run.
            Gremlin will run as many of the eligible Reliability Tests that it
            can during the specified window. At a minimum, we will need a two
            hour window.
          </Typography>
        </Stack>
        <ScheduleWindow
          activeDayFieldName="scheduleSettings.activeDays"
          disabled={!isAutoSchedulingEnabled}
          endTimeFieldName="scheduleSettings.end"
          startTimeFieldName="scheduleSettings.start"
          sx={{ marginLeft: 3, paddingBottom: 2 }}
        />
      </div>
    </>
  )
}
